import { type JSX, useState } from "react";

import SearchInput from "common/components/SearchInput";
import useDebounce from "common/hooks/useDebounce";

import SelectionFilter from "./SelectionFilter";

interface SearchInputFilterProps {
  label: string;
  renderTagsComponent: (resetInputValue: () => void) => JSX.Element;
  children: (query: string, resetInputValue: () => void) => JSX.Element;
  renderExtraComponent?: (resetInputValue: () => void) => JSX.Element;
}

// a SelectionFilter wrapper that provides a search input
export default function SearchInputFilter({
  label,
  renderTagsComponent,
  children,
  // this optional component is rendered above the input field
  renderExtraComponent = null,
}: SearchInputFilterProps) {
  const [inputValue, setInputValue] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useDebounce(inputValue, 300);

  function resetInputValue() {
    setDebouncedQuery("");
    setInputValue("");
  }

  return (
    <SelectionFilter
      label={label}
      tagsComponent={renderTagsComponent(resetInputValue)}
    >
      {renderExtraComponent?.(resetInputValue)}

      <SearchInput
        value={inputValue}
        placeholder={`Search ${label.toLowerCase()}`}
        onChange={(e) => setInputValue(e.target.value)}
        onClear={() => setInputValue("")}
      />

      {children(debouncedQuery, resetInputValue)}
    </SelectionFilter>
  );
}
